export default __webpack_public_path__ + "static/media/brainhealth-project-logo-white.2371cd60.svg";